var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "pageLoading" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "desktopToWeb" } }, [
      _c("div", { attrs: { id: "loader-wrapper" } }, [
        _c("div", { attrs: { id: "loader" } }),
        _c("div", { staticClass: "loader-section section-left" }),
        _c("div", { staticClass: "loader-section section-right" }),
        _c("div", { staticClass: "load_title" }, [
          _vm._v("正在加载系统资源，请耐心等待"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }